module.exports = __webpack_public_path__ + "img/dices-top-left.9b7c7a15.svg";